export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/va04dc7ccb68cfe174abfdae5a8d4ba51df63eb56-runtime-main.69dc66361fe0e668b7c3.worker.js");
}
